export interface IEvent {
    [key: string]: {
        objectID: string
        type: EventType,
        time: string
    }
}

export enum EventType {
    PowerEvent = 'power-event',
    TemperatureAlert = 'temperature-alert',
    PowerAlert = 'power-alert'
}

const date = new Date(2022, 6, 16).toDateString()

export const events: IEvent[] = [
    {
        "1": {
            objectID: "WTG002",
            type: EventType.PowerEvent,
            time: date
        }
    },
    {
        "2": {
            objectID: 'WTG0034',
            type: EventType.PowerAlert,
            time: date
        }
    },
    {
        "3": {
            objectID: 'WTG0043',
            type: EventType.TemperatureAlert,
            time: date
        }
    },
]
